import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { useCallback } from 'react';
import { SettingsRow } from '../../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../../interfaces/Settings/SettingsValueType';
import { getSettingsValue, getUpdatedSettings } from '../../../utils/Settings';
import { sharedStyles } from '../../../utils/Style';
import { GenericSettingsValue } from '../../../interfaces/Settings/GenericSettingsValue';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { SettingsTabContentProps } from '../../../interfaces/Settings/SettingsTabContentProps';

interface HomepageSettingsRowDef {
  name: string;
  statusKey: string;
}

const rowDefs: HomepageSettingsRowDef[] = [
  {
    name: 'Kaydırıcı',
    statusKey: 'slider_status',
  },
  {
    name: 'Popüler Ürünler',
    statusKey: 'popular_products_status',
  },
  {
    name: 'Haftanın Ürünleri',
    statusKey: 'hightlights_status',
  },
  {
    name: 'Bugünün Popülerleri',
    statusKey: 'daily_products_status',
  },
  {
    name: 'Banner 1',
    statusKey: 'banner_status',
  },
  {
    name: 'Markalar',
    statusKey: 'brands_status',
  },
  {
    name: 'Blog',
    statusKey: 'blogs_status',
  },
];

export const HomepageSettings = (props: SettingsTabContentProps) => {
  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      props.onChange(
        getUpdatedSettings(
          SettingsType.FRONTEND,
          key,
          props.settings,
          newValue,
        ),
      ),
    [props.settings],
  );

  const handleSave = () => {
    props.onSave(['slider_status', ...rowDefs.map((row) => row.statusKey)]);
  };

  return (
    <Paper
      sx={{
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        height: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Typography
        sx={{
          ...sharedStyles.h5,
          fontWeight: 'bold',
        }}
      >
        Anasayfa Aktif-Pasiflik
      </Typography>
      <Divider />
      {rowDefs.map((row, i) => (
        <Box
          key={i}
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
        >
          <SettingsRow
            key={row.name}
            name={row.name}
            valueType={SettingsValueType.BOOLEAN}
            value={getSettingsValue(props.settings, row.statusKey)}
            onChange={(newValue) => handleChange(row.statusKey, newValue)}
          />
        </Box>
      ))}
      <Box sx={{ display: 'flex', flexGrow: 1 }} />
      <Box display='flex' justifyContent='flex-end'>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
        >
          Kaydet
        </Button>
      </Box>
    </Paper>
  );
};
